<template>
  <div class="wg-row">
    <wg-modal
      v-if="openPicker"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openPicker = false"
    >
      <div slot="body">
        <world-date-picker
          v-if="isFrom"
          :from="
            from == null || from == ''
              ? $moment().unix()
              : Number($moment(from).format('X'))
          "
          @customFunction="setFrom"
        ></world-date-picker>
        <world-date-picker
          v-else
          :from="
            to == null || to == ''
              ? $moment().unix()
              : Number($moment(to).format('X'))
          "
          @customFunction="setTo"
        ></world-date-picker>
      </div>
    </wg-modal>
    <div class="wg-row">
      <div class="vertical-height-div" style="height: 5px"></div>
      <!-- Statistiche standard -->
      <!-- Filtri date -->
      <div class="wg-row" style="flex-wrap: nowrap; align-items: center">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, "From", "Da") }}
        </div>
        <div class="horizontal-height-div" style="width: 10px"></div>
        <div
          ref="date-from"
          class="input-date-picker-label"
          @click="
            openPicker = !openPicker;
            isFrom = true;
          "
        >
          {{ from ? from : "-" }}
        </div>
        <div class="horizontal-height-div" style="width: 30px"></div>
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, "To", "A") }}
        </div>
        <div class="horizontal-height-div" style="width: 10px"></div>
        <div
          ref="date-to"
          class="input-date-picker-label"
          @click="
            openPicker = !openPicker;
            isFrom = false;
          "
        >
          {{ to ? to : "-" }}
        </div>
        <div class="horizontal-height-div" style="width: 20px"></div>
        <template v-if="from || to">
          <div class="horizontal-height-div" style="width: 10px"></div>
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Reset', 'Reset')"
            @click="
              from = null;
              to = null;
            "
          />
        </template>
      </div>
      <div class="vertical-height-div" style="height: 20px"></div>
      <div v-if="!totalFeed && totalProjects.length == 0" class="wg-row" style="justify-content: center">
        <div class="com-anm22-app-text-xxl">
          {{
            $anm22.strLang(
              lang,
              "Enter feed or associate projects to display the analytics",
              "Inserire feed o progetti per visualizzare le statistiche"
            )
          }}
        </div>
      </div>
      <template v-else>
        <div v-if="totalFeed" class="wg-row">
          <div class="com-anm22-app-text-xxl" style="font-weight: bold">
            {{ $anm22.strLang(lang, "Totals", "Totali") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div class="wg-row cake-row com-anm22-app-custom-scroll">
          <cake :scale="0.7" v-if="totalFeed" :obj="totalFeed" />
          <cake :scale="0.7" v-if="totalFeedCall" :obj="totalFeedCall" />
          <cake :scale="0.7" v-if="totalFeedCallReplied" :obj="totalFeedCallReplied" />
          <cake :scale="0.7" v-if="totalFeedCallNotReplied" :obj="totalFeedCallNotReplied" />
          <cake :scale="0.7" v-if="totalFeedMeeting" :obj="totalFeedMeeting" />
          <cake :scale="0.7" v-if="totalFeedMsg" :obj="totalFeedMsg" />
          <cake
            :scale="0.7"
            v-if="totalFeedActionMsg"
            :obj="totalFeedActionMsg"
          />
        </div>
        <template v-if="totalFeedCall">
          <div class="vertical-height-div" style="height: 20px"></div>
          <div class="wg-row">
            <div class="com-anm22-app-text-xxl" style="font-weight: bold">
              {{
                $anm22.strLang(
                  lang,
                  "Totals call by channel",
                  "Totale chiamate per canale"
                )
              }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div class="wg-row cake-row com-anm22-app-custom-scroll">
            <cake :scale="0.7" v-if="totalOthersCall" :obj="totalOthersCall" />
            <template
              v-for="c in categories.filter((c) => c.type.includes('call'))"
            >
              <cake
                :scale="0.7"
                :key="'category-call' + c.id"
                v-if="totalByChannel('call', c)"
                :obj="totalByChannel('call', c)"
              />
            </template>
          </div>
        </template>
        <template v-if="totalFeedMsg">
          <div class="vertical-height-div" style="height: 20px"></div>
          <div class="wg-row">
            <div class="com-anm22-app-text-xxl" style="font-weight: bold">
              {{
                $anm22.strLang(
                  lang,
                  "Total msgs by channel",
                  "Totale messaggi per canale"
                )
              }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div class="wg-row cake-row com-anm22-app-custom-scroll">
            <cake :scale="0.7" v-if="totalOthersMsgs" :obj="totalOthersMsgs" />
            <template
              v-for="(c, index) in categories.filter((c) =>
                c.type.includes('msg')
              )"
            >
              <cake
                :key="'category-msg-' + index"
                :scale="0.7"
                v-if="totalByChannel('msg', c)"
                :obj="totalByChannel('msg', c)"
              />
            </template>
          </div>
        </template>
        <template v-if="totalProjects.length != 0">
          <div class="vertical-height-div" style="height: 20px"></div>
          <div class="wg-row">
            <div class="com-anm22-app-text-xxl" style="font-weight: bold">
              {{ $anm22.strLang(lang, "Projects", "Progetti") }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div class="wg-row cake-row com-anm22-app-custom-scroll">
            <cake
              :scale="0.7"
              v-if="totalProjectsObj"
              :obj="totalProjectsObj"
              :customBorder="2"
            />
            <cake
              :scale="0.7"
              v-if="totalProjectsWaitingObj"
              :obj="totalProjectsWaitingObj"
            />
            <cake
              :scale="0.7"
              v-if="totalProjectsRunningObj"
              :obj="totalProjectsRunningObj"
            />
            <cake
              :scale="0.7"
              v-if="totalProjectsCompletedObj"
              :obj="totalProjectsCompletedObj"
            />
            <cake
              :scale="0.7"
              v-if="totalProjectsInvoicedObj"
              :obj="totalProjectsInvoicedObj"
            />
            <cake
              :scale="0.7"
              v-if="totalProjectsCanceledObj"
              :obj="totalProjectsCanceledObj"
            />
            <cake
              :scale="0.7"
              v-if="totalProjectsProvisionalObj"
              :obj="totalProjectsProvisionalObj"
            />
          </div>
        </template>
        <template v-if="checkUsers">
          <div class="vertical-height-div" style="height: 20px"></div>
          <input
            type="button"
            :value="
              showUserStatistics
                ? $anm22.strLang(
                    lang,
                    'Hide users statistics',
                    'Nascondi statistiche utenti'
                  )
                : $anm22.strLang(
                    lang,
                    'Show users statistics',
                    'Mostra statistiche utenti'
                  )
            "
            @click="showUserStatistics = !showUserStatistics"
          />
        </template>
        <template v-if="checkUsers && showUserStatistics">
          <div class="vertical-height-div" style="height: 50px"></div>
          <div v-if="checkUsers" class="wg-row">
            <div class="com-anm22-app-text-xxl" style="font-weight: bold">
              {{ $anm22.strLang(lang, "Users", "Utenti") }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div
            v-for="(u, i) in users.filter((u) => totalUserFeed(u))"
            :key="'user-' + i"
            class="wg-row"
            style="margin-bottom: 30px"
          >
            <div
              class="wg-row"
              style="white-space: nowrap; align-items: center"
            >
              <div style="min-width: 22px; width: 22px; height: 22px">
                <world-object-icon
                  :type="'user'"
                  :obj="u"
                  :isImg="true"
                ></world-object-icon>
              </div>
              <div style="margin-left: 4px" class="com-anm22-app-text-xl">
                {{ u.name + " " + u.surname }}
              </div>
            </div>
            <div class="vertical-height-div" style="height: 20px"></div>
            <div class="wg-row">
              <div class="com-anm22-app-text-xxl" style="font-weight: bold">
                {{ $anm22.strLang(lang, "Totals", "Totali") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height: 20px"></div>
            <div class="wg-row cake-row com-anm22-app-custom-scroll">
              <cake
                :scale="0.7"
                v-if="totalUserFeed(u)"
                :obj="totalUserFeed(u)"
              />
              <cake
                :scale="0.7"
                v-if="totalUserFeedCall(u)"
                :obj="totalUserFeedCall(u)"
              />
              <cake
                :scale="0.7"
                v-if="totalUserFeedCallReplied(u)"
                :obj="totalUserFeedCallReplied(u)"
              />
              <cake
                :scale="0.7"
                v-if="totalUserFeedCallNotReplied(u)"
                :obj="totalUserFeedCallNotReplied(u)"
              />
              <cake
                :scale="0.7"
                v-if="totalUserFeedMeeting(u)"
                :obj="totalUserFeedMeeting(u)"
              />
              <cake
                :scale="0.7"
                v-if="totalUserFeedMsg(u)"
                :obj="totalUserFeedMsg(u)"
              />
              <cake
                :scale="0.7"
                v-if="totalUserFeedActionMsg(u)"
                :obj="totalUserFeedActionMsg(u)"
              />
            </div>
            <template v-if="totalUserFeedCall(u)">
              <div class="vertical-height-div" style="height: 20px"></div>
              <div class="wg-row">
                <div class="com-anm22-app-text-xxl" style="font-weight: bold">
                  {{
                    $anm22.strLang(
                      lang,
                      "Totals call by channel",
                      "Totale chiamate per canale"
                    )
                  }}
                </div>
              </div>
              <div class="vertical-height-div" style="height: 20px"></div>
              <div class="wg-row cake-row com-anm22-app-custom-scroll">
                <cake
                  :scale="0.7"
                  v-if="totalUserOthersCall(u)"
                  :obj="totalUserOthersCall(u)"
                />
                <template
                  v-for="c in categories.filter((c) => c.type.includes('call'))"
                >
                  <cake
                    :scale="0.7"
                    :key="'category-call-user' + c.id"
                    v-if="totalUserByChannel('call', c, u)"
                    :obj="totalUserByChannel('call', c, u)"
                  />
                </template>
              </div>
            </template>
            <template v-if="totalUserFeedMsg(u)">
              <div class="vertical-height-div" style="height: 20px"></div>
              <div class="wg-row">
                <div class="com-anm22-app-text-xxl" style="font-weight: bold">
                  {{
                    $anm22.strLang(
                      lang,
                      "Total msgs by channel",
                      "Totale messaggi per canale"
                    )
                  }}
                </div>
              </div>
              <div class="vertical-height-div" style="height: 20px"></div>
              <div class="wg-row cake-row com-anm22-app-custom-scroll">
                <cake
                  :scale="0.7"
                  v-if="totalUserOthersMsgs(u)"
                  :obj="totalUserOthersMsgs(u)"
                />
                <template
                  v-for="(c, index) in categories.filter((c) =>
                    c.type.includes('msg')
                  )"
                >
                  <cake
                    :scale="0.7"
                    :key="'category-msg-user' + index"
                    v-if="totalUserByChannel('msg', c, u)"
                    :obj="totalUserByChannel('msg', c, u)"
                  />
                </template>
              </div>
            </template>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import Cake from "./statistics/Cake.vue";
import WorldDatePicker from "../../../../world/spa/components/WorldDatePicker.vue";

export default {
  props: {
    contactId: [Number, String],
  },
  data() {
    return {
      isFrom: false,
      openPicker: false,
      from: null,
      to: null,
      totalProjects: [],
      waitingProjects: [],
      runningProjects: [],
      invoicedProjects: [],
      completedProjects: [],
      provisionalProjects: [],
      canceledProjects: [],
      showUserStatistics: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      offline: (state) => state.offline.isOffline,
      windowWidth: (state) => state.windowWidth
    }),
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.contact.workOwner
      );
    },
    checkUsers() {
      if (this.users.filter((u) => this.totalUserFeed(u)).length > 0) {
        return 1;
      }
      return 0;
    },
    categories() {
      return [
        {
          id: "whatsapp",
          label: "Whatsapp",
          type: ["msg"]
        },
        {
          id: "fb",
          label: "Facebook",
          type: ["msg"]
        },
        {
          id: "messenger",
          label: "Messenger",
          type: ["msg", "call"]
        },
        {
          id: "zoom",
          label: "Zoom",
          type: ["msg", "call"]
        },
        {
          id: "discord",
          label: "Discord",
          type: ["msg", "call"]
        },
        {
          id: "sms",
          label: "Sms",
          type: ["msg"]
        },
        {
          id: "email",
          label: "Email",
          type: ["msg"]
        },
        {
          id: "ig",
          label: "Instagram",
          type: ["msg"]
        },
        {
          id: "hang",
          label: "Hangouts",
          type: ["msg", "call"]
        },
        {
          id: "skype",
          label: "Skype",
          type: ["msg", "call"]
        },
        {
          id: "teams",
          label: "Microsoft Teams",
          type: ["msg", "call"]
        },
        {
          id: "linkedin",
          label: "Linkedin",
          type: ["msg"]
        },
        {
          id: "twitter",
          label: "X",
          type: ["msg"]
        },
        {
          id: "slack",
          label: "Slack",
          type: ["msg", "call"]
        },
        {
          id: "meet",
          label: "Google Meet",
          type: ["msg", "call"]
        },
      ];
    },
    feed() {
      return this.$store.getters["messageChannels/get"](this.contact.feed);
    },
    msgs() {
      return this.feed
        ? this.$store.getters["messages/getByChannel"](
            this.feed.idWorldMessageChannel
          ).filter((m) => m.data.type != "reminder")
        : [];
    },
    contact() {
      return this.$store.getters["contacts/get"](this.contactId);
    },
    users() {
      let users = [];
      this.msgs.forEach((m) => {
        if (!users.includes(m.createdBy)) {
          users.push(m.createdBy);
        }
      });
      return users
        .map((u) => this.$store.getters["users/get"](u))
        .filter((u) => u);
    },
    //Statistiche
    totalProjectsObj() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();

      const projects = this.totalProjects.filter((project) => {
        let result = !!project;
        // date filters
        if (this.from) {
          result = result && !!project.startDate && project.startDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!project.startDate && project.startDate < toTs + 86399;
        }
        return result;
      });
      const total = projects.length;
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Totals".toUpperCase(),
              "Totali".toUpperCase()
            ),
            val: total,
            color: "#ccc"
          }
        : null;
    },
    totalProjectsWaitingObj() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const projects = this.waitingProjects.filter((project) => {
        let result = !!project;
        // date filters
        if (this.from) {
          result = result && !!project.startDate && project.startDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!project.startDate && project.startDate < toTs + 86399;
        }
        return result;
      });
      const total = projects.length;
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Waiting".toUpperCase(),
              "In attesa".toUpperCase()
            ),
            val: total,
            color: "#bdbdbd"
          }
        : null;
    },
    totalProjectsRunningObj() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const projects = this.runningProjects.filter((project) => {
        let result = !!project;
        // date filters
        if (this.from) {
          result = result && !!project.startDate && project.startDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!project.startDate && project.startDate < toTs + 86399;
        }
        return result;
      });
      const total = projects.length;
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Running".toUpperCase(),
              "In corso".toUpperCase()
            ),
            val: total,
            color: "#ffeb3b"
          }
        : null;
    },
    totalProjectsCompletedObj() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const projects = this.completedProjects.filter((project) => {
        let result = !!project;
        // date filters
        if (this.from) {
          result = result && !!project.startDate && project.startDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!project.startDate && project.startDate < toTs + 86399;
        }
        return result;
      });
      const total = projects.length;
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Completed".toUpperCase(),
              "Completati".toUpperCase()
            ),
            val: total,
            color: "#01d479"
          }
        : null;
    },
    totalProjectsInvoicedObj() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const projects = this.invoicedProjects.filter((project) => {
        let result = !!project;
        // date filters
        if (this.from) {
          result = result && !!project.startDate && project.startDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!project.startDate && project.startDate < toTs + 86399;
        }
        return result;
      });
      const total = projects.length;
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Invoiced".toUpperCase(),
              "Fatturati".toUpperCase()
            ),
            val: total,
            color: "#00b0ff"
          }
        : null;
    },
    totalProjectsProvisionalObj() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const projects = this.provisionalProjects.filter((project) => {
        let result = !!project;
        // date filters
        if (this.from) {
          result = result && !!project.startDate && project.startDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!project.startDate && project.startDate < toTs + 86399;
        }
        return result;
      });
      const total = projects.length;

      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Provisional".toUpperCase(),
              "Provvisori".toUpperCase()
            ),
            val: total,
            color: "#fff"
          }
        : null;
    },
    totalProjectsCanceledObj() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const projects = this.canceledProjects.filter((project) => {
        let result = !!project;
        // date filters
        if (this.from) {
          result = result && !!project.startDate && project.startDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!project.startDate && project.startDate < toTs + 86399;
        }
        return result;
      });
      const total = projects.length;
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Canceled".toUpperCase(),
              "Annullati".toUpperCase()
            ),
            val: total,
            color: "#ff0000"
          }
        : null;
    },
    totalFeed() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.type == '';
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const totalDuration = msgs
        .filter((m) => m.data.type == "call" || m.data.type == "meeting")
        .reduce((hours, msg) => hours + (msg.data.duration || 0), 0);
      const total = msgs.length;
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Feed".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Feed".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            val: total,
            reference:
              totalDuration != null ? this.hoursToText(totalDuration) : null,
            color: "#ccc"
          }
        : null;
    },
    totalOthersCall() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          !!m &&
          m.data.type == "call" &&
          (!m.data.category ||
            m.data.category == "" ||
            m.data.category == "other");
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Generics".toUpperCase() + "<br>" + "Numbers/Hours".toUpperCase(),
              "Generiche".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            reference:
              totalDuration != null ? this.hoursToText(totalDuration) : "",
            val: total,
            color: "#ccc",
            icon: "phoneWhite",
            iconBackground: "orange"
          }
        : null;
    },
    totalOthersMsgs() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          !!m &&
          m.data.type == "msg" &&
          (!m.data.category ||
            m.data.category == "" ||
            m.data.category == "other");
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "Generics", "Generici")
              .toUpperCase(),
            val: total,
            color: "#ccc",
            icon: "chatWhite",
            iconBackground: "#0aabf4"
          }
        : null;
    },
    totalFeedCallNotReplied() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.data.type == "call" && m.data.callResponse &&  (m.data.callResponse == 'notexist' || m.data.callResponse == 'notreplied');
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalCallDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Not replied".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Non risposte".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            icon: "phoneDisabled",
            iconBackground: "white",
            val: total,
            reference:
              totalCallDuration != null
                ? this.hoursToText(totalCallDuration)
                : null,
            color: "#ccc"
          }
        : null;
    },
    totalFeedCallReplied() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.data.type == "call" && (!m.data.callResponse || (m.data.callResponse &&  m.data.callResponse == 'replied' ));
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalCallDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Replied".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Risposte".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            icon: "phone",
            iconBackground: "white",
            val: total,
            reference:
              totalCallDuration != null
                ? this.hoursToText(totalCallDuration)
                : null,
            color: "#ccc"
          }
        : null;
    },
    totalFeedCall() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.data.type == "call";
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalCallDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Call".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Chiamate".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            icon: "phoneWhite",
            iconBackground: "orange",
            val: total,
            reference:
              totalCallDuration != null
                ? this.hoursToText(totalCallDuration)
                : null,
            color: "#ccc"
          }
        : null;
    },
    totalFeedMsg() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.data.type == "msg";
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "Msgs", "Messaggi")
              .toUpperCase(),
            val: total,
            icon: "chatWhite",
            iconBackground: "#0aabf4",
            color: "#ccc"
          }
        : null;
    },
    totalFeedActionMsg() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.data.type == "actionMsg";
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "External feed", "Messaggi esterni")
              .toUpperCase(),
            val: total,
            color: "#ccc"
          }
        : null;
    },
    totalFeedMeeting() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.data.type == "meeting";
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalMeetingDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Meeting".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Meeting".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            reference:
              totalMeetingDuration != null
                ? this.hoursToText(totalMeetingDuration)
                : null,
            val: total,
            color: "#ccc",
            icon: "placeWhite",
            iconBackground: "red"
          }
        : null;
    }
  },
  methods: {
    getImageByCategory(category) {
      switch (category) {
        case "meet":
          return "googleMeet";
          break;
        case "twitter":
          return "twitter";
          break;
        case "sms":
          return "chatWhite";
          break;
        case "slack":
          return "slack";
          break;
        case "whatsapp":
          return "whatsapp";
          break;
        case "zoom":
          return "zoomLogo";
          break;
        case "fb":
          return "facebook";
          break;
        case "email":
          return "email";
          break;
        case "ig":
          return "instagram";
          break;
        case "hang":
          return "hangouts";
          break;
        case "skype":
          return "skype";
          break;
        case "linkedin":
          return "linkedin";
          break;
        case "messenger":
          return "messenger";
          break;
        case "discord":
          return "discord";
          break;
        case "teams":
          return "microsoftTeams";
          break;
      }
    },
    totalByChannel(type, c) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          c.id == "email"
            ? !!m &&
              m.data.type == type &&
              m.data.category &&
              (m.data.category == "email" || m.data.category == "inbox")
            : !!m &&
              m.data.type == type &&
              m.data.category &&
              m.data.category == c.id;
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalDuration =
        type == "call"
          ? msgs.reduce((hours, msg) => hours + (msg.data.duration || 0), 0)
          : null;
      return total != 0
        ? {
            label:
              type != null && type == "call"
                ? this.$anm22.strLang(
                    this.lang,
                    c.label.toUpperCase() +
                      "<br>" +
                      "Number/Hours".toUpperCase(),
                    c.label.toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
                  )
                : this.$anm22.strLang(
                    this.lang,
                    c.label.toUpperCase(),
                    c.label.toUpperCase()
                  ),
            reference:
              totalDuration != null ? this.hoursToText(totalDuration) : "",
            val: total,
            color: "#ccc",
            icon: this.getImageByCategory(c.id),
            iconBackground: c.id == "sms" ? "#0aabf4" : null
          }
        : null;
    },

    totalUserByChannel(type, c, u) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          c.id == "inbox" || c.id == "email"
            ? !!m &&
              m.data.type == type &&
              m.data.category &&
              (m.data.category == "email" || m.data.category == "inbox")
            : !!m &&
              m.data.type == type &&
              m.data.category &&
              m.data.category == c.id;
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        result = result && m.createdBy == u.idWorldUser;
        return result;
      });
      const total = msgs.length;
      const totalDuration =
        type == "call"
          ? msgs.reduce((hours, msg) => hours + (msg.data.duration || 0), 0)
          : null;
      return total != 0
        ? {
            label:
              type != null && type == "call"
                ? this.$anm22.strLang(
                    this.lang,
                    c.label.toUpperCase() +
                      "<br>" +
                      "Number/Hours".toUpperCase(),
                    c.label.toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
                  )
                : this.$anm22.strLang(
                    this.lang,
                    c.label.toUpperCase(),
                    c.label.toUpperCase()
                  ),
            reference:
              totalDuration != null ? this.hoursToText(totalDuration) : "",
            val: total,
            color: "#ccc",
            icon: this.getImageByCategory(c.id),
            iconBackground: c.id == "sms" ? "#0aabf4" : null
          }
        : null;
    },
    totalUserFeedCallNotReplied(user) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.createdBy == user.idWorldUser && m.data.type == "call" && m.data.callResponse &&  (m.data.callResponse == 'notexist' || m.data.callResponse == 'notreplied');
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalCallDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Not replied".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Non risposte".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            icon: "phoneDisabled",
            iconBackground: "white",
            val: total,
            reference:
              totalCallDuration != null
                ? this.hoursToText(totalCallDuration)
                : null,
            color: "#ccc"
          }
        : null;
    },
    totalUserFeedCallReplied(user) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.createdBy == user.idWorldUser && m.data.type == "call" && (!m.data.callResponse || (m.data.callResponse &&  m.data.callResponse == 'replied' ));
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalCallDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Replied".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Risposte".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            icon: "phone",
            iconBackground: "white",
            val: total,
            reference:
              totalCallDuration != null
                ? this.hoursToText(totalCallDuration)
                : null,
            color: "#ccc"
          }
        : null;
    },
    totalUserOthersMsgs(user) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          !!m &&
          m.data.type == "msg" &&
          m.createdBy == user.idWorldUser &&
          (!m.data.category ||
            m.data.category == "" ||
            m.data.category == "other");
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "Generics", "Generici")
              .toUpperCase(),
            val: total,
            color: "#ccc",
            icon: "chatWhite",
            iconBackground: "#0aabf4"
          }
        : null;
    },
    totalUserOthersCall(user) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          !!m &&
          m.data.type == "call" &&
          m.createdBy == user.idWorldUser &&
          (!m.data.category ||
            m.data.category == "" ||
            m.data.category == "other");
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Generics".toUpperCase() + "<br>" + "Numbers/Hours".toUpperCase(),
              "Generiche".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            reference:
              totalDuration != null ? this.hoursToText(totalDuration) : "",
            val: total,
            color: "#ccc",
            icon: "phoneWhite",
            iconBackground: "orange"
          }
        : null;
    },
    totalUserFeedActionMsg(user) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          !!m && m.data.type == "actionMsg" && m.createdBy == user.idWorldUser;
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "External feed", "Messaggi esterni")
              .toUpperCase(),
            val: total,
            color: "#ccc"
          }
        : null;
    },
    totalUserFeedMsg(user) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          !!m && m.data.type == "msg" && m.createdBy == user.idWorldUser;
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "Msgs", "Messaggi")
              .toUpperCase(),
            val: total,
            color: "#ccc",
            icon: "chatWhite",
            iconBackground: "#0aabf4"
          }
        : null;
    },
    totalUserFeedMeeting(user) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          !!m && m.data.type == "meeting" && m.createdBy == user.idWorldUser;
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalMeetingDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Meeting".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Meeting".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            reference:
              totalMeetingDuration != null
                ? this.hoursToText(totalMeetingDuration)
                : null,
            val: total,
            color: "#ccc",
            icon: "placeWhite",
            iconBackground: "red"
          }
        : null;
    },
    totalUserFeed(user) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result = !!m && m.createdBy == user.idWorldUser && m.type == '';
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const totalDuration = msgs
        .filter((m) => m.data.type == "call" || m.data.type == "meeting")
        .reduce((hours, msg) => hours + (msg.data.duration || 0), 0);
      const total = msgs.length;
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Feed".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Feed".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            val: total,
            reference:
              totalDuration != null ? this.hoursToText(totalDuration) : null,
            color: "#ccc"
          }
        : null;
    },
    totalUserFeedCall(user) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const msgs = this.msgs.filter((m) => {
        let result =
          !!m && m.data.type == "call" && m.createdBy == user.idWorldUser;
        // date filters
        if (this.from) {
          result = result && !!m.ts && m.ts > fromTs;
        }
        if (this.to) {
          result = result && !!m.ts && m.ts < toTs + 86399;
        }
        return result;
      });
      const total = msgs.length;
      const totalCallDuration = msgs.reduce(
        (hours, msg) => hours + (msg.data.duration || 0),
        0
      );
      return total != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Call".toUpperCase() + "<br>" + "Number/Hours".toUpperCase(),
              "Chiamate".toUpperCase() + "<br>" + "Numero/Ore".toUpperCase()
            ),
            val: total,
            reference:
              totalCallDuration != null
                ? this.hoursToText(totalCallDuration)
                : null,
            color: "#ccc",
            icon: "phoneWhite",
            iconBackground: "orange"
          }
        : null;
    },
    getUserExpenses(userId) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const expenses = this.outgoes.filter((o) => {
        let result = !!o && o.user === userId;
        // date filters
        if (this.from) {
          result = result && o.outgoDate > fromTs;
        }
        if (this.to) {
          result = result && o.outgoDate < toTs + 86399;
        }
        return result;
      });
      const total = expenses.reduce((tot, o) => tot + o.amount, 0);
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "Expenses", "Spese")
              .toUpperCase(),
            val: total,
            unit: "EUR",
            color: "#ccc"
          }
        : null;
    },
    hoursToText(value) {
      let string = "";
      const hours = Math.floor(value / 3600),
        minutes = Math.floor((value % 3600) / 60);
      string += `${hours}h`;
      if (minutes !== 0) {
        string += ` ${minutes}m`;
      }
      return string;
    },
    setFrom(newDate) {
      this.from = newDate;
      this.openPicker = false;
    },
    setTo(newDate) {
      this.to = newDate;
      this.openPicker = false;
    },
    loadData() {
      Promise.all(
        ["messages","messageChannels"].map((d) => {
          return this.$store.dispatch(d + "/load", this.$vlf(d));
        })
      ).then((result) => {
        this.$Progress.finish();
      });
    },
    getData() {
      this.$http
        .get("contact/analytics?idContact=" + this.contactId)
        .then((response) => {
          if (response.data) {
            Promise.all([
              this.$store.dispatch("messageChannels/update", {
              vlf: this.$vlf("messageChannels"),
              objs: [response.data.feed]
              }),
              this.$store.dispatch("messages/update", {
                vlf: this.$vlf("messages"),
                objs: response.data.messages,
                cleanFilters: [(m) => m.channel == response.data.feed.idWorldMessageChannel],
              }),
              (this.totalProjects = response.data.totalProjects),
              (this.waitingProjects = response.data.waitingProjects),
              (this.runningProjects = response.data.runningProjects),
              (this.invoicedProjects = response.data.invoicedProjects),
              (this.completedProjects = response.data.completedProjects),
              (this.provisionalProjects = response.data.provisionalProjects),
              (this.canceledProjects = response.data.canceledProjects)
            ]).catch((error) => console.log(error));
          }
        })
        .catch((error) => console.log(error));
    }
  },
  created() {
    if (this.contact.workOwner == 474) {
      if(this.userPermission <= 3) {
        this.loadData();
        this.getData();
      } else {
         this.$emit("changePage", "feed");
      }
    } else {
      this.loadData();
      this.getData();  
    }
  },
  components: {
    Cake,
    WorldDatePicker,
    "vue-simple-spinner": Spinner,
  }
};
</script>

<style lang="scss" scoped>
.icon-picker {
  cursor: pointer;
  opacity: 0.7;
}
.input-date-picker-label {
  width: 100%;
  max-width: 300px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  display: block;
  box-shadow: none;
  background-color: #eee;
  border: 1px solid #eee;
  min-height: 36px;
  font-size: 12px;
  cursor: pointer;
}
.job-icon {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #007fff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  user-select: none;
  font-size: 14px;
}
.cake-row {
  overflow-x: auto;
  max-width: 100%;
  white-space: nowrap;
  flex-wrap: nowrap;
}

// @media only screen and (max-width: 349px) {
//   .cake-row {
//     justify-content: center;

//   }
// }
</style>